
<template>
  <el-dialog
      title="发送公告"
      :visible="visible"
      width="530px"
      @close="setVisible(false)"
      :close-on-click-modal="true"
  >
    <ConfigForms ref="msgForm" :form-items="formItems"></ConfigForms>
    <div slot="footer" class="dialog-footer">
      <el-button @click="setVisible(false)" size="medium">取 消</el-button>
      <el-button type="primary" @click="confirmSend" size="medium">确 认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ConfigForms from '../../../../components/config-forms/index.vue'
import { innerLinkList, noticeTypes } from '../../../../config';

export default {
  name: 'EditNotice',
  emits: ['submit'],
  components: { ConfigForms },
  data() {
    return {
      visible: false,
      formItems: [
        // { label: '用户ID', type: 'text', key: 'uid' },
        { label: '公告类型', required: true, type: 'select', key: 'type', options: noticeTypes },
        { label: '活动链接', type: 'select', key: 'link', options: innerLinkList },
        { label: '公告内容', required: true, type: 'textarea', key: 'content', options: innerLinkList },
      ]
    };
  },

  mounted() {
    
  },

  methods: {
    setVisible(val) {
      this.visible = val
    },
    async confirmSend() {
      try {
        const data = await this.$refs.msgForm.validate()
        const output = Object.assign({}, data)
        if (output.uid) {
          output.uid = parseInt(output.uid)
        }
        this.$emit('submit', output)
      } catch (error) {
        
      }
    },
    open() {
      this.setVisible(true)
    },
    close() {
      this.setVisible(false)
    }
  },
};
</script>

<style lang="scss" scoped>

</style>